
import { Component, Vue, Watch } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import timestatistical from "./components/timestatistical.vue"
import breadCharts from "./components/bread-charts.vue"
import columnCharts from "./components/column-charts.vue";
import RadioButton from '@/components/radio-button.vue';
import {
	getSearchDate,
	nextDay
} from "@/utils";
import {
	dataStatisProductSellAnalysispriceSellDistribution,
	dataStatisProductSellAnalysisproductSellCountAnalysis,
	dataStatisProductSellAnalysisproductOrderOverview,
	dataStatisProductSellAnalysisteamSellCountAnalysis,
	dataStatisProductSellAnalysiscategorySellCountAnalysis,
	dataStatisdataStatisMemberTeamSingleProductAnalysis,
	dataStatisProductSellAnalysisProductRetailRankList
} from "@/api/material"
import {
	productCategory,
	productOpenTimeLabelFilterList
} from "@/api/supplier"

import { imgHost } from '@/utils/config';
import Dialog from '@/components/dialog.vue';
import { defaultHeader } from "@/utils/config";

import {
	getToday,
	getYestarDay,
	getBeforeYestarDay,
	getInSevenDay
} from '@/utils/index';

@Component({
	name: '',
	components: {
		PageFooter,
		PickerDate,
		timestatistical,
		breadCharts,
		columnCharts,
		'slz-dialog': Dialog,
		RadioButton
	}
})
export default class ProductList extends Vue {
	private defaultHeader = defaultHeader
	private explainShow = false
	private imgurl = imgHost
	private placeorderloading = false;
	private placeorderloading2 = false
	private shopsalesloading = false
	private type1 = 1;
	private time1: any = []
	private type2 = 1;
	private time2: any = []
	private breaddata: any = []
	private tablelist: any = []
	private teamShop = ''
	private teamShoplist: any = []
	private columndata: any = []
	private ordermsg: any = {}
	private orderanalyselist: any = []
	private keywords = ''
	private keywords1 = ''
	private keywords2 = ''
	private tableloading = false
	private lines: any = []
	private classity = ''
	private categorytablelist: any = []
	private categorytableloading = false
	private sortmsg: any = {
		prop: 'SubmitProductCount',
		order: 'descending'
	}
	private salessortmsg: any = {
		prop: 'SellProductCount',
		order: 'descending'
	}

	private editableTabsValue = '0'
	private editableTabs = [
		{
			title: '商品销量分析',
			name: '0',
			type: 1,
			productId: 0,
			keywords: ''
		}
	]
	private currentPage = 1
	private pagesize = 10
	private total = 0
	private currentProductId = 0;
	private currentType = 1;

	private filterTime:any = '';
	private selectTime = 0;
	private timeScope:any = [{
			label: '今日',
			value: 1
		}, {
			label: '昨日',
			value: 2
		}, {
			label: '前天',
			value: 3
		}
	]
	private timeTypes = [
		{ value: 6, label: '今日', type: 'time', format: 'HH:mm:ss', valueformat: 'HH:mm:ss' },
		{ value: 1, label: '自然日', type: 'date', format: 'yyyy-MM-dd', valueformat: 'yyyy-MM-dd' },
		{ value: 2, label: '自然周', type: 'week', format: 'yyyy 第 WW 周', valueformat: 'yyyy-MM-dd' },
		{ value: 3, label: '自然月', type: 'month', format: 'yyyy-MM', valueformat: 'yyyy-MM' },
		{ value: 4, label: '近7天', type: 'daterange', format: 'yyyy-MM-dd', valueformat: 'yyyy-MM-dd' },
		{ value: 5, label: '近30天', type: 'daterange', format: 'yyyy-MM-dd', valueformat: 'yyyy-MM-dd' },
	]

	private openTimeLabel = '';
	private openTimeLabelList: any = [];
	private categoryList: any = [];
	private categoryId = null;

	@Watch ('editableTabsValue')
	private getProductId(){
		this.editableTabs.map(item=>{
			if (item.name === this.editableTabsValue){
				this.currentProductId = item.productId;
				this.currentType = item.type;
				this.keywords = item.keywords;
			}
		})
		this.clicktabs();
	}
	@Watch ('keywords')
	private keywordsChange(){
		this.editableTabs.map(item=>{
			if (item.name === this.editableTabsValue){
				item.keywords = this.keywords;
			}
		})
	}

	

	private mounted() {
		this.time1 = getSearchDate(2)
		this.time2 = getSearchDate(2)
		this.getordersurvey()
		this.getorderanalyse()
		this.getcategorytablelist()
		this.getsalestablelist()
		this.getOpenTimeLabel();
		this.getProductCategory();
	}

	private emptyTime(){
		this.filterTime = ''
		this.selectTime = 0
	}
	private handleTimeScopeChange(e){
		console.log(e)
		if (e === 1){
			this.filterTime = getToday();
		}
		if (e === 2){
			this.filterTime = getYestarDay();
		}
		if (e === 3){
			this.filterTime = getBeforeYestarDay();
		}
		if (e === 4){
			this.filterTime = getInSevenDay();
		}

		this.clicktabs()
	}

	private async getProductCategory() {
		try {
			const res: any = await productCategory({
				Skip: 0,
				Take: 999999,
			});
			this.categoryList = res.Result.Results.map(item => {
				return {
					value: item.Id,
					label: item.CategoryName
				}
			});
		} catch (e) {
			console.log('productlist ===>', e)
		}
	}
	/**
	 * 获取开团日期标签
	 */
	private async getOpenTimeLabel(){
		try {
			const res: any = await productOpenTimeLabelFilterList({
				Skip: 0,
				Take: 999999,
			});
			this.openTimeLabelList = res.Result.map((item, i)=>{
				return {
					value: i,
					label: item.OpenTimeLabel
				}
			});
		} catch (e) {
			console.log('productlist ===>', e)
		}
	}

	private exportfile(type) {
		let url = location.origin
		if (type == 1) {
			url += '/pc/dataStatisProductSellAnalysis/categorySellCountAnalysis'
			url += '?Keywords=' + encodeURIComponent(this.classity)
			url += '&TimeType=' + this.type2 || ''
			url += '&StartDate=' + this.time2[0] || ''
			url += '&EndDate=' + this.time2[1] || ''
			url += '&Sort=' + this.sortmsg.prop || ''
			url += '&IsAsc=' + (this.sortmsg.order == 'ascending' ? true : false)
		} else {
			if (this.editableTabsValue == '0') {
				let times = [];
				if (this.filterTime){
					times = this.filterTime.split('/');
				}

				url += '/pc/dataStatisProductSellAnalysis/productSellCountAnalysisExport'
				url += '?Keywords=' + encodeURIComponent(this.keywords)
				url += '&TimeType=' + this.type2 || ''
				url += '&StartDate=' + this.time2[0] || ''
				url += '&EndDate=' + this.time2[1] || ''
				url += '&Sort=' + this.salessortmsg.prop || ''
				url += '&IsAsc=' + (this.salessortmsg.order == 'ascending' ? true : false)
				url += '&ProductOpenStartDate=' + (times[0] || '')
				url += '&ProductOpenEndDate=' + (times[1] || '')
				url += '&OpenTimeLabel=' + (this.openTimeLabelList[this.openTimeLabel]?.label || '')
				url += '&ProductCategoryIds=' + (this.categoryId || '')
			} else if (this.currentType === 1) {
				url += '/pc/dataStatis/dataStatisMemberTeamSingleProductAnalysis'
				url += '?ProductId=' + this.currentProductId
				url += '&StartDate=' + this.time2[0] || ''
				url += '&EndDate=' + this.time2[1] || ''
				url += '&Keywords=' + encodeURIComponent(this.keywords)
			} else{
				url += '/pc/dataStatisProductSellAnalysis/productRetailRankList'
				url += '?ProductId=' + this.currentProductId
				url += '&StartDate=' + this.time2[0] || ''
				url += '&EndDate=' + this.time2[1] || ''
				url += '&Keywords=' + encodeURIComponent(this.keywords)
			}
		}

		window.open(url)
	}
	private togoal(name) {
		const element: any = document.querySelectorAll(`.${name}`)[0]
		element.scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		})
	}
	private gettime(e, num) {
		let type = 'type' + num
		let time = 'time' + num
		this[type] = e.type
		this[time] = e.time
		this.currentPage = 1
		if (num == 1) {
			this.getordersurvey()
			this.getorderanalyse()
		} else if (num == 2) {
			this.getcategorytablelist()
			// this.getsalestablelist()
			this.clicktabs()
		}
	}
	private refresh() {
		this.getcategorytablelist()
		this.getsalestablelist()
	}
	private async getordersurvey() {
		try {
			this.placeorderloading = true
			let data: any = {
				TimeType: this.type1,
				StartDate: this.time1[0],
				EndDate: this.time1[1]
			}
			let res = await dataStatisProductSellAnalysisproductOrderOverview(data)
			if (res.IsSuccess) {
				this.ordermsg = res.Result
			}
		} finally {
			this.placeorderloading = false
		}
	}
	private async getorderanalyse() {
		try {
			this.placeorderloading2 = true
			let data: any = {
				TimeType: this.type1,
				StartDate: this.time1[0],
				EndDate: this.time1[1]
			}
			let res = await dataStatisProductSellAnalysispriceSellDistribution(data)
			if (res.IsSuccess) {
				this.orderanalyselist = res.Result.map(v => {
					return {
						value: v.ProductCount,
						name: v.StartOrderMoney + (v.IsMax ? '元以上' : ('~' + v.EndOrderMoney + '元')),
						label: v.StartOrderMoney + (v.IsMax ? '元以上' : ('~' + v.EndOrderMoney + '元')) + '   商品销量'
					}
				})
			}
		} finally {
			this.placeorderloading2 = false
		}
	}
	private conversion(a: number, b: number) {
		let num: any = 0
		if (a == 0 && b == 0) {
			num = 0 + '%'
		} else if (a == 0) {
			num = -100 + '%'
		} else if (b == 0) {
			num = 100 + '%'
		} else {
			num = (a / b * 100).toFixed(2) + '%'
		}
		return num
	}
	private async getcategorytablelist() {
		try {
			this.categorytableloading = true
			let data: any = {
				Keywords: this.classity,
				TimeType: this.type2,
				StartDate: this.time2[0],
				EndDate: this.time2[1],
				Sort: this.sortmsg.prop,
				IsAsc: this.sortmsg.order == 'ascending' ? true : false
			}
			let res = await dataStatisProductSellAnalysiscategorySellCountAnalysis(data)
			if (res.IsSuccess) {
				this.categorytablelist = res.Result
			}
		} finally {
			this.categorytableloading = false
		}
	}
	private async getsalestablelist() {
		try {
			this.tableloading = true
			this.shopsalesloading = true
			let data: any = {
				Keywords: this.keywords,
				TimeType: this.type2,
				StartDate: this.time2[0],
				EndDate: this.time2[1],
				Sort: this.salessortmsg.prop,
				IsAsc: this.salessortmsg.order == 'ascending' ? true : false,
				OpenTimeLabel: this.openTimeLabelList[this.openTimeLabel]?.label,
				ProductCategoryIds: this.categoryId
			}

			if (this.filterTime){
				var splitList = this.filterTime.split('/');
				data.ProductOpenStartDate = splitList[0];
				data.ProductOpenEndDate = splitList[1] || '';
			}

			let res = await dataStatisProductSellAnalysisproductSellCountAnalysis(data)
			if (res.IsSuccess) {
				const {
					TotalStatistic, Result
				} = res.Result;
				this.tablelist = Result;
				if (TotalStatistic){
					this.tablelist.unshift({
						ProductName: '总计',
						...TotalStatistic
					});
				}
				if (this.tablelist.length) {
					this.teamShop = Result[0]?.ProductId
					this.teamShoplist = Result.map(v => {
						return {
							value: v.ProductId,
							label: v.ProductName
						}
					})
					this.getsalescharts()
				} else {
					this.teamShop = ''
					this.teamShoplist = []
					this.columndata = []
					this.lines = []

					// let columncharts:any = this.$refs.columncharts
					// columncharts.clearChart()
				}
			}
		} finally {
			this.shopsalesloading = false
			this.tableloading = false
		}
	}
	private async getsalescharts() {
		try {
			this.shopsalesloading = true
			let data: any = {
				ProductId: this.teamShop,
				StartDate: this.time2[0],
				EndDate: this.time2[1],
			}
			let res = await dataStatisProductSellAnalysisteamSellCountAnalysis(data)
			if (res.IsSuccess) {
				this.columndata = res.Result.filter((v, i) => {
					return i < 10
				})
				this.lines = [
					{ key: 'SellProductCount', name: '销售数量' },
					{ key: 'CollectProductCount', name: '已汇总数量' },
					{ key: 'CancelProductCount', name: '已取消数量' },
				]
			}
		} finally {
			this.shopsalesloading = false
			this.tableloading = false
		}
	}

	private sortmethod(col) {
		// console.log(col)
		if (col.order) {
			this.sortmsg = {
				prop: col.prop,
				order: col.order
			}
		} else {
			this.sortmsg = {
				prop: 'SubmitProductCount',
				order: false
			}
		}
		this.getcategorytablelist()
	}
	private sortmethod2(col) {
		if (col.order) {
			this.salessortmsg = {
				prop: col.prop,
				order: col.order
			}
		} else {
			this.salessortmsg = {
				prop: 'SellProductCount',
				order: false
			}
		}
		this.getsalestablelist()
	}
	private clicktabs() {

		this.currentPage = 1
		if (this.editableTabsValue == '0') {
			this.getsalestablelist()
		} else {
			if (this.currentType === 1){
				this.getshoplist()
			}else if (this.currentType === 2){
				this.getRanks();
			}
			
		}
	}
	private handleToRank(row){
	

		let query = {
			id: row.ProductId,
			startTime: this.time2[0],
			endTime: this.time2[1],
			name: row.ProductName
		}

		this.$router.push({
			name: 'productSaleRank',
			query: query
		})
	}
	private onceanalysis(row, type) {
		let key = row.ProductId+'-'+type;
		let ishas = this.editableTabs.find(v => {
			return v.name == key
		})
		if (!ishas?.name) {
			this.editableTabs.push({
				title: (type == 2 ? '[零售排行]':'') + row.ProductName,
				name: key,
				type: type,
				productId: row.ProductId,
				keywords: ''
			})
		}
		this.editableTabsValue = key
		this.clicktabs()
	}
	private async getshoplist() {
		try {
			this.tableloading = true
			let data: any = {
				ProductId: this.currentProductId,
				Keywords: this.keywords,
				StartDate: this.time2[0],
				EndDate: this.time2[1],
				Skip: (this.currentPage - 1) * this.pagesize,
				Take: this.pagesize
			}
			let res = await dataStatisdataStatisMemberTeamSingleProductAnalysis(data)
			if (res.IsSuccess) {
				this.tablelist = res.Result.Results
				this.total = res.Result.Total
			}
		} finally {
			this.tableloading = false
		}
	}
	private async getRanks(){
		try {
			this.tableloading = true
			let data: any = {
				ProductId: this.currentProductId,
				Keywords: this.keywords,
				StartDate: this.time2[0],
				EndDate: this.time2[1],
				Skip: (this.currentPage - 1) * this.pagesize,
				Take: this.pagesize
			}
			let res = await dataStatisProductSellAnalysisProductRetailRankList(data)
			if (res.IsSuccess) {
				this.tablelist = res.Result.Results
				this.total = res.Result.Total
			}
		} finally {
			this.tableloading = false
		}
	}
	private handleSizeChange(e) {
		this.currentPage = 1
		this.pagesize = e
		if (this.currentType === 1){
			this.getshoplist()
		}else if (this.currentType === 2){
			this.getRanks();
		}
	}
	private handleCurrentChange(e) {
		this.currentPage = e
		if (this.currentType === 1){
			this.getshoplist()
		}else if (this.currentType === 2){
			this.getRanks();
		}
	}
	private removeTab(e) {
		this.editableTabs = this.editableTabs.filter(v => {
			return v.name != String(e)
		})
		this.editableTabsValue = '0'
	}
	private handleClearFilter(){
		this.keywords = '';
		if (this.editableTabsValue == '0'){
			this.filterTime = '';
			this.selectTime = 0;
			this.openTimeLabel = '';
			this.categoryId = null;
		}
		this.currentPage = 1;
		this.clicktabs();
	}
}
